import React, { useEffect } from "react";
import {
  Box,
  Card,
  Stack,
  Typography,
  Avatar,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
} from "@mui/material";
import { Icon } from "@iconify/react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { productFindById } from "../slice";
import { RootState } from "@app/redux/root-reducer";

const ProducDetail = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const { productId } = location.state as { productId: number };

  const { productData } = useSelector((state: RootState) => ({
    productData: state.allProductReducer.productFindById.data,
  }));

  useEffect(() => {
    if (productId) {
      dispatch(productFindById({ productId: Number(productId) }));
    }
  }, [dispatch, productId]);

  // Show loading indicator while fetching
  if (!productData) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "60vh",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  const car = productData?.car || {};

  return (
    <Box p={3}>
      {/* Car Info Card */}
      <Card sx={{ p: 3, border: "1px solid #1572D3", borderRadius: 2 }}>
        <Stack direction={{ xs: "column", sm: "row" }} spacing={3}>
          <Avatar
            src={car.images && car.images.length > 0 ? car.images[0].url : ""}
            variant="rounded"
            sx={{ width: 200, height: 150, borderRadius: 2 }}
          />

          <Stack spacing={1}>
            {[
              { label: "Brand", value: car.brand?.name || "N/A" },
              { label: "Model", value: car.model?.name || "N/A" },
              { label: "Year", value: car.manufacturingYear || "N/A" },
              { label: "Fuel Type", value: car.engineType || "N/A" },
              { label: "Kilometers", value: car.driven || "N/A" },
              { label: "Color", value: car.color || "N/A" },
              {
                label: "Insurance",
                value: car.insuranceAvailable ? "Yes" : "No",
              },
            ].map((item) => (
              <Stack direction="row" key={item.label}>
                <Typography
                  sx={{ width: 120, fontWeight: 600, color: "#404040" }}
                >
                  {item.label}:
                </Typography>
                <Typography sx={{ fontWeight: 500, color: "#5F5F5F" }}>
                  {item.value}
                </Typography>
              </Stack>
            ))}
          </Stack>
        </Stack>
      </Card>

      {/* Rating History */}
      <Box mt={4}>
        <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
          Rating History
        </Typography>

        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                 <TableCell>Name</TableCell>
                 <TableCell>Date</TableCell>
                <TableCell>Rating</TableCell>
                <TableCell>Review</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {car.reviews && car.reviews.length > 0 ? (
                car.reviews.map((review: any, index: number) => (
                  <TableRow key={review.id || index}>
                    <TableCell>{review.user.firstName}</TableCell>
                    <TableCell>
                      {new Date(review.createdAt).toLocaleDateString()}
                    </TableCell>
                    <TableCell>
                      {Array.from({ length: 5 }).map((_, i) => (
                        <Icon
                          key={i}
                          icon={
                            i < review.rating ? "mdi:star" : "mdi:star-outline"
                          }
                          color="#FFD700"
                        />
                      ))}
                    </TableCell>
                    <TableCell>{review.comment}</TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={3} align="center">
                    No Reviews Found
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Box>
  );
};

export default ProducDetail;
